import { ViewEncapsulation, Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/shared/global.service";
import { UrlService } from "src/app/shared/services/url.service";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/shared/services/alert.service";
import { Router } from "@angular/router";
import { UtilService } from "src/app/shared/services/util.service";
import { UrlControl } from "src/app/shared/models/generic.model";
import { ConstantesService } from "src/app/shared/services/constantes.service";
import { ConfirmationModalOptions } from "src/app/shared/models/modal.model";
import { DominiosService } from "src/app/shared/services/dominios.service";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal,
} from "@ng-bootstrap/ng-bootstrap";
import { AgendaComponent } from "../agenda/agenda.component";
import * as moment from "moment";

declare var $: any;
@Component({
  selector: "app-reprogramar-turno",
  templateUrl: "./reprogramar-turno.component.html",
  styleUrls: ["../solicitar-turno/solicitar-turno.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

/**
 * @author jnmartinez
 */
export class ReprogramarTurnoComponent implements OnInit {
  tramites: any[] = [];
  sedes: any[] = [];
  motivoPrioridad: any[] = [];
  tipoDiscapacidad: any[] = [];
  modalConfirmMessage: ConfirmationModalOptions;
  parametros: string[] = [DominiosService.SEDE_POR_DEFECTO];

  agenda: any;
  agendaData: any;
  visitante: any;
  prioridad = false;
  isDiscapacidad = false;

  constructor(
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private utils: UtilService,
    public router: Router,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal
  ) {}
  // tslint:disable: triple-equals
  ngOnInit() {
    this.agenda = {};
    this.visitante = {};
    this.visitante.numDocVisitante = sessionStorage.getItem(
      ConstantesService.NUM_DOC_SESSSION
    );
    this.visitante.tipoDocVisitante = sessionStorage.getItem(
      ConstantesService.TIPO_DOC_SESSSION
    );
    this.consultarTramites();
    this.obtenerDominio("Sede", "sedes");
    this.obtenerDominio("TipoDiscapacidad", "tipoDiscapacidad");
    this.obtenerDominio("MotivoPrioridad", "motivoPrioridad");
    this.consultarParametros();
    this.consultarAgendaVirtual();
  }

  /**
   * Método que valida si se diligencio la sede para iniciar el proceso de busqueda de
   * @author jnmartinez
   */
  public obtenerAgenda() {
    if (this.agenda.sede) {
      const modalRef = this.modalService.open(AgendaComponent, {
        centered: true,
        size: "lg",
      });
      modalRef.componentInstance.agenda = this.agenda;

      modalRef.result.then(
        (result) => {
          let diff: number = moment(result.fechaInicio).diff(
            moment(new Date()),
            "minutes"
          );
          //console.log(diff);
          if (diff > 0) {
            this.agenda.fechaInicio = result.fechaInicio;
            this.agenda.fechaFin = result.fechaFin;
          } else {
            this.utils.cathException(
              "No es posible agendar un turno con fecha anterior a la actual",
              this.alertService,
              this.spinner
            );
          }
        },
        (reason) => {
          if (
            reason === ModalDismissReasons.ESC ||
            reason === ModalDismissReasons.BACKDROP_CLICK
          ) {
          }
        }
      );
    }
  }

  /**
   * Consulta de dominios
   * @param filtro indica el nombre del dominio a consultar
   * @param lista indica la lista en la que se almacena el resultado
   * @return void
   */
  public obtenerDominio(filtro, lista) {
    this.spinner.show();
    const serviceProvider = "ObtenerDominio";
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(["filterBy=detalleDominioPK.nombreDominio", filtro]);
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_TRANS
    );
    this.global.getPublico(url).subscribe(
      (data) => {
        if (filtro === "Sede") {
          data.forEach((sede) => {
            if (sede.valor === "Virtual") {
              this[lista][0] = sede;
            }
          });
        } else {
          this[lista] = data;
        }

        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(
          "No es posible los valores inciales de la aplicación",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  /**
   * Consulta de dominios
   * @param filtro indica el nombre del dominio a consultar
   * @param lista indica la lista en la que se almacena el resultado
   * @return void
   */
  public consultarAgendaVirtual() {
    this.spinner.show();
    const serviceProvider = "consultaAgendaVirtual";
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push([
      "filterBy=idAgendaVirtual",
      this.agendaData.idAgendaVirtual,
    ]);
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_UAC
    );
    this.global.getPublico(url).subscribe(
      (data) => {
        this.agenda = data[0];
        if (this.agenda.motivoPrioridad) {
          this.prioridad = true;
          this.validarMotivo();
        }
        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(
          "No es posible los valores inciales de la aplicación",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  public consultarParametros() {
    const serviceProvider = "consultarParametros";
    const url = this.urlService.getUrlTransversal(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_TRANS
    );
    this.global.postPublico(url, this.parametros).subscribe((data) => {
      if (!this.validarCampo(this.agenda.sede)) {
        this.agenda.sede = data[0].valor;
      }
    });
  }

  /**
   * Método que obtiene el listado de servicios disponibles
   * @author jnmartinez
   */
  public consultarTramites() {
    this.spinner.show();
    const serviceProvider = "tramiteUAC";
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push([
      "filterBy=estado",
      ConstantesService.ESTADO_TRAMITE_ACTIVO,
    ]);
    let url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, pathParams, null),
      this.urlService.hostAPI_UAC
    );
    url = url + "&orderBy=nombre$ASC";
    this.global.getPublico(url).subscribe(
      (data) => {
        this.tramites = data.filter((tramite) => tramite.letraTurno != "AF");
        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(
          "Ocurrio un error en la consulta de los servicios",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  /**
   * Método que valida si la agenda tiene prioridad o no
   * y reinicia los filtros dependientes
   * @author jnmartinez
   */
  validarPrioridad() {
    if (!this.prioridad) {
      this.agenda.motivoPrioridad = undefined;
      this.agenda.tipoDiscapacidad = undefined;
      this.isDiscapacidad = false;
    }
  }

  /**
   * Método que valida si la prioridad de la agenda es discapacidad fisica
   * @author jnmartinez
   */
  validarMotivo() {
    if (
      this.agenda.motivoPrioridad ==
      DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD
    ) {
      this.isDiscapacidad = true;
    } else {
      this.isDiscapacidad = false;
      this.agenda.tipoDiscapacidad = undefined;
    }
  }

  /**
   * Método que realiza el proceso
   * @author jnmartinez
   */
  public reprogramarTurno() {
    if (!this.validarCampos()) {
      this.alertService.generateAlertError(
        "Diligenciar la información requerida",
        ""
      );
    } else {
      this.reprogramarSolicitud();
    }
  }

  /**
   * Método que realiza el registro de la solicitud de turno virtual
   * @author jnmartinez
   */
  public reprogramarSolicitud() {
    this.spinner.show();
    const serviceProvider = "actualizarTurnoVirtual";
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_UAC
    );
    console.log(this.agenda);
    this.global.postPublico(url, this.agenda).subscribe(
      (data) => {
        this.alertService.generateAlertSuccess(
          "Se reprogramó el turno virtual exitosamente",
          ""
        );
        this.activeModal.close(this.agenda);
        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(err, this.alertService, this.spinner);
      }
    );
  }

  cancelar() {
    this.activeModal.close({});
  }

  /**
   * Método que valida la completitud de datos del formulario
   * @author jnmartinez
   */
  public validarCampos() {
    return (
      this.validarCampo(this.agenda.tramite) &&
      this.validarCampo(this.agenda.sede) &&
      this.validarCampo(this.agenda.fechaInicio) &&
      this.validarCampo(this.agenda.fechaFin) &&
      (!this.prioridad ||
        (this.validarCampo(this.agenda.motivoPrioridad) &&
          (this.agenda.motivoPrioridad !=
            DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD ||
            this.validarCampo(this.agenda.tipoDiscapacidad))))
    );
  }

  public validarCampo(campo) {
    return this.utils.validarCamposObligatorios(campo);
  }
}
